<template>
  <div class="flex flex-col gap-4">
    <TextHeader class="border-none pb-0!">Berichten</TextHeader>
    <TabsComponent :tabs="tabs" />
    <RouterView />
  </div>
</template>

<script setup>
import { computed } from "vue"
import TabsComponent from "@/components/navigation/TabsComponent.vue"
import useUserStore from "@/stores/userStore.js"
import { TextHeader } from "@repowerednl/ui-component-library"

const tabs = computed(() => [
  {
    name: "Notificaties",
    route: "messages-notifications",
  },
  ...(useUserStore().hasFlag("can-see-my-messages")
    ? [
        {
          name: "Mijn berichten",
          route: "messages-overview",
        },
      ]
    : []),
  {
    name: "Contact",
    route: "messages-contact",
  },
])
</script>
